/*
 * @Description:
 * @Author: yingbin
 * @Date: 2019-07-12 12:55:41
 * @LastEditTime: 2019-08-09 15:56:18
 * @LastEditors: yingbin
 */

import request from "@/util/request";
import util from "@/util/util";
import myLocalStorage from "@/util/crypto.js";
class home {
  /**登录 */
  login(code){
    return new Promise((resolve, reject) => {
      request.post(self, {
        action: "kdyserver.wechat.code2Session4PC",
        option:true,
        data: {
          code
        }
      }).then(res => {
        if (res.success && res.body.result) {
          resolve({
            success: true,
            data: res.body
          })
        } else { 
          resolve({
            success: false
          })
        }
      })
    });  
  }
  // //**是否为快递员实名 */
  // hasRealName(self) {
  //   return new Promise((resolve, reject) => {
  //     request
  //       .post(self, {
  //         action: "kdyserver.realName.checking",
  //         data: {
  //           account_id: util.getCookie("account_id"),
  //         }
  //       })
  //       .then(res => {
  //         // debugger
  //         if (res.success) {
  //              resolve({
  //               // success: true,
  //               data: res.body
  //             });
  //           // if (res.body.result) {
  //           //   resolve({
  //           //     success: true,
  //           //     data: res.body.data
  //           //   });
  //           // } else {
  //           //   resolve({
  //           //     success: false,
  //           //     data: {
  //           //       code: res.body.code,
  //           //       error: res.body.message || res.body.remark
  //           //     }
  //           //   });
  //           //   self.$message.error(res.body.message || res.body.remark);
  //           // }
  //         }
  //       });
  //   });
  // }
 //**不使用业务员实名 */
 setRealName(self,data) {
  return new Promise((resolve, reject) => {
    request
      .post(self, {
        action: "kdyserver.realName.checking.update",
        data
      })
      .then(res => {
        // debugger
       
          if (res.body.result) {
            resolve({
              success: true,
              data: res.body
            });
          } else {
            resolve({
              success: false,
              data: {
                code: res.body,
                error: res.body.message || res.body.remark
              }
            });
            self.$message.error(res.body.message || res.body.remark);
          }
        
      });
  });
}
  /**业务员登录 */
  staffLogin(self){
    return new Promise((resolve, reject) => {
      request.post(self, {
        action: "kdyserver.ywy.smslogin",
        option:true,
        data: {
          "mobile": myLocalStorage.encrypt(self.phoneForm.mobile),
          "sms_code": myLocalStorage.encrypt(self.phoneForm.sms_code)
        }
      }).then(res => {
        if (res.success && res.body.result) {
          resolve({
            success: true,
            data: res.body
          })
        } else {
          resolve({
            success: false
          })
          // debugger
          self.$message.error(res.body.message || res.body.remark);
        }
      })
    });  
  }
  /**业务员登录时获取验证码 */
  getSmsCode(self){
    return new Promise((resolve, reject) => {
      request.post(self, {
        action: "kdyserver.ywy.sendsmscode",
        option:false,
        data: {
          "mobile": self.phoneForm.mobile,
          "sms_type": 'login'
        }
      }).then(res => {
        if (res.success && res.body.result) {
          resolve({
            success: true,
            data: res.body
          })
        } else {
          // debugger
          resolve({
            success: false,
            // msg:res.body
          })
          self.$message.error(res.body.message || res.body.remark);
        }
      })
    });  
  }
  /**判断是否绑定过业务员 */
  hasbind(self) {
    return new Promise((resolve, reject) => {
      request
        .post(self, {
          action: "kdyserver.account.hasbind",
          data: {
            account_id: util.getCookie("account_id"),
          }
        })
        .then(res => {
          if (res.success) {
            if (res.body.result) {
              resolve({
                success: true,
                data: res.body.data
              });
            } else {
              resolve({
                success: false,
                data: {
                  code: res.body.code,
                  error: res.body.message || res.body.remark
                }
              });
              self.$message.error(res.body.message || res.body.remark);
            }
          }
        });
    });
  }
  // 
  /**账号密码登录*/
  accountLogin(self, isPwdType){
    let paramData = {}
    if (!isPwdType) {
      paramData = {
        "account_type": self.loginTab==1 ? "user":'ywy' ,//'ywy','user'
        "phone": self.phoneForm.mobile,
        "valid_code": self.phoneForm.sms_code,
        "sms_type": "login"
      }
    } else {
       paramData = {
        "account_type": self.loginTab==1?"user":'ywy' ,//'ywy','user'
        "encrypt_account_id": self.loginForm.account_id ? myLocalStorage.encrypt(self.loginForm.account_id):'',
        "password":self.loginTab==1?myLocalStorage.encrypt(self.loginForm.password):myLocalStorage.encrypt(self.loginForm.passwordTwo),
        "phone":self.loginForm.phone ? myLocalStorage.encrypt(self.loginForm.phone):'',
      }
    }
    return new Promise((resolve, reject) => {
      request.post(self, {
        action: "kdyserver.account.login",
        option:true,
        data: paramData
      }).then(res => {
        if (res.success && res.body.code!=500) {
          resolve({
            success: true,
            data: res.body
          })
        } else {
          resolve({
            success: false,
            // msg:res.body
          })
          self.$message.error(res.body.message || res.body.remark);
        }
      })
    });  
  }
  /**解析地址 */
  doAnalysis(self, analysisInfo) {
    return new Promise((resolve, reject) => {
      request
        .post(self, {
          action: "kdyserver.address.analysisAddress",
          data: {
            account_id: util.getCookie("account_id"),
            address_info: analysisInfo,
          }
        })
        .then(res => {
          if (res.success) {
            if (res.body.result) {
              resolve({
                success: true,
                data: res.body.data
              });
            } else {
              resolve({
                success: false,
                data: {
                  code: res.body.code,
                  error: res.body.message || res.body.remark
                }
              });
              self.$message.error(res.body.message || res.body.remark);
            }
          }
        });
    });
  }
  /**创建订单或提交协议快递员 */
  createParcel(self, data) {
    return new Promise((resolve, reject) => {
      request
        .post(self, {
          action: "kdyserver.order.createMiniappsOrder",
          data
        })
        .then(res => {
          if (res.success) {
            if (res.body.result) {
              resolve({
                success: true,
                data: res.body.data
              });
            } else {
              resolve({
                success: false,
                data: {
                  code: res.body.code,
                  error: res.body.message || res.body.remark
                }
              });
              self.$message.error(res.body.message || res.body.remark);
            }
          }
        });
    });
  }
  /**直接打印 */
  Printing(self, data) {
    return new Promise((resolve, reject) => {
      request
        .post(self, {
          action: "kdyserver.print.directPrintOrder",
          data
        })
        .then(res => {
          if (res.success) {
            if (res.body.result) {
              resolve({
                success: true,
                data: res.body.data
              });
            } else {
              resolve({
                success: false,
                data: {
                  code: res.body.code,
                  error: res.body.message || res.body.remark
                }
              });
              self.$message.error(res.body.message || res.body.remark);
            }
          }
        });
    });
  }
  /**单个创建收寄件地址信息 */
  CreateAddress(self, type_name, flag, collect) {
    let msg = {
      account_id: util.getCookie("account_id"),
      name: self.ruleForm[type_name].name,
      phone: self.ruleForm[type_name].phone,
      address: self.ruleForm[type_name].address,
      province_code: self.ruleForm[type_name].province_code,
      city_code: self.ruleForm[type_name].city_code,
      district_code: self.ruleForm[type_name].area_code,
      address_type: type_name == 'send' ? 1 : 0,
      address_id:self.ruleForm[type_name].address_id//地址 id
    };
    if (flag == "R") {
      // 添加收件人
      msg = {
        id:collect.id,
        account_id: util.getCookie("account_id"),
        name: collect.receiver_name,
        phone: collect.receiver_phone,
        address: collect.receiver_address,
        province_code: collect.receiver_province_code,
        city_code: collect.receiver_city_code,
        district_code: collect.receiver_district_code,
        address_type: 0,
        address_id:collect.address_id
      };
    }
    return new Promise((resolve, reject) => {
      request
        .post(self, {
          action: "kdyserver.address.pc.createAddress",
          data: msg
        })
        .then(res => {
          if (res.success) {
            if (res.body.result) {
              resolve({
                success: true,
                data: res.body.data
              });
            } else {
              resolve({
                success: false,
                data: {
                  code: res.body.code,
                  error: res.body.message || res.body.remark
                }
              });
              self.$message.error(res.body.message || res.body.remark);
            }
          }
        });
    });
  }

  /**批量创建收件人 */
  createMultiple(multiple) {
    return new Promise((resolve, reject) => {
      request
        .post(self, {
          action: "kdyserver.address.createAddress",
          data: multiple
        })
        .then(res => {
          if (res.success) {
            if (res.body.result) {
              resolve({
                success: true,
                data: res.body.data
              });
            } else {
              resolve({
                success: false,
                data: {
                  code: res.body.code,
                  error: res.body.message || res.body.remark
                }
              });
              self.$message.error(res.body.message || res.body.remark);
            }
          }
        });
    });
  }
  /**获取默认寄件人地址 */
  getDefaultAddress(self){
    return new Promise((resolve, reject) => {
      request
        .post(self, {
          action: "kdyserver.address.getDefaultAddress",
          data: {
            account_id: util.getCookie("account_id"), 
            address_type:2
          }
        })
        .then(res => {
          if (res.success) {
            if (res.body.code == 200) {
              resolve({
                success: true,
                data: res.body.data
              });
            } else {
              resolve({
                success: false,
                data: {
                  code: res.body.code,
                  error: res.body.message || res.body.remark
                }
              });
              self.$message.error(res.body.message || res.body.remark);
            }
          }
        });
    });
  }
  /**获取收/寄件人列表信息 */
  getAddressList(self, flag, page) {
    return new Promise((resolve, reject) => {
      request
        .post(self, {
          action: "kdyserver.address.queryAddressList",
          data: {
            account_id: util.getCookie("account_id"),
            key_word: self.keyword,
            address_type: flag,
            current_page: page,
            page_size: self.page_size || 10
          }
        })
        .then(res => {
          if (res.success) {
            if (res.body.result) {
              resolve({
                success: true,
                data: res.body.data
              });
            } else {
              resolve({
                success: false,
                data: {
                  code: res.body.code,
                  error: res.body.message || res.body.remark
                }
              });
              self.$message.error(res.body.message || res.body.remark);
            }
          }
        });
    });
  }
  /**搜索收寄件人信息*/
  searchInfo(self, flag) {
    return new Promise((resolve, reject) => {
      request
        .post(self, {
          action: "ydgj.address.searchByKeyword",
          data: {
            account_id: utils.getCookie("account_id"),
            keyword: self.keyword,
            rs_type: flag
          }
        })
        .then(res => {
          if (res.success) {
            if (res.body.result) {
              resolve({
                success: true,
                data: res.body.data
              });
            } else {
              resolve({
                success: false,
                data: {
                  code: res.body.code,
                  error: res.body.message || res.body.remark
                }
              });
              self.$message.error(res.body.message || res.body.remark);
            }
          }
        });
    });
  }
  /**获取包裹信息 */
  getParcel(self, pacel_id) {
    return new Promise((resolve, reject) => {
      request
        .post(self, {
          action: "ydgj.parcel.getParcel",
          data: {
            account_id: utils.getCookie("account_id"),
            parcel_ids: pacel_id
          }
        })
        .then(res => {
          if (res.success) {
            if (res.body.result) {
              resolve({
                success: true,
                data: res.body.data
              });
            } else {
              resolve({
                success: false,
                data: {
                  code: res.body.code,
                  error: res.body.message || res.body.remark
                }
              });
              self.$message.error(res.body.message || res.body.remark);
            }
          }
        });
    });
  }
  /**编辑包裹信息 */
  updateParcel(self,data) {
    return new Promise((resolve, reject) => {
      request
        .post(self, {
          action: "kdyserver.file.checkTempOrder",
          data
        })
        .then(res => {
          if (res.success) {
            if (res.body.result) {
              resolve({
                success: true,
                data: res.body.data
              });
            } else {
              resolve({
                success: false,
                data: {
                  code: res.body.code,
                  error: res.body.message || res.body.remark
                }
              });
              self.$message.error(res.body.message || res.body.remark);
            }
          }
        });
    });
  }
  /**获取省 */
  getProvince(){
    return new Promise((resolve, reject) => {
      request
        .post(self, {
          action: "kdyserver.address.queryProvince",
          data: {}
        })
        .then(res => {
          if (res.success) {
            if (res.body.result) {
              resolve({
                success: true,
                data: res.body.data
              });
            } else {
              resolve({
                success: false,
                data: {
                  code: res.body.code,
                  error: res.body.message || res.body.remark
                }
              });
              self.$message.error(res.body.message || res.body.remark);
            }
          }
        });
    });
  }
  /**获取市 */
  getCity(code){
    return new Promise((resolve, reject) => {
      request
        .post(self, {
          action: "kdyserver.address.queryCity",
          data: {
            province_code: code,
          }
        })
        .then(res => {
          if (res.success) {
            if (res.body.result) {
              resolve({
                success: true,
                data: res.body.data
              });
            } else {
              resolve({
                success: false,
                data: {
                  code: res.body.code,
                  error: res.body.message || res.body.remark
                }
              });
              self.$message.error(res.body.message || res.body.remark);
            }
          }
        });
    });
  }
  /**获取区 */
  getDistrict(code){
    return new Promise((resolve, reject) => {
      request
        .post(self, {
          action: "kdyserver.address.queryDistrict",
          data: {
            city_code: code
          }
        })
        .then(res => {
          if (res.success) {
            if (res.body.result) {
              resolve({
                success: true,
                data: res.body.data
              });
            } else {
              resolve({
                success: false,
                data: {
                  code: res.body.code,
                  error: res.body.message || res.body.remark
                }
              });
              self.$message.error(res.body.message || res.body.remark);
            }
          }
        });
    });
  }
  /**地址更新 */
  updateAddress(self,data){
    return new Promise((resolve, reject) => {
      request
        .post(self, {
          action: "kdyserver.address.updateAddress",
          data 
        })
        .then(res => {
          if (res.success) {
            if (res.body.result) {
              resolve({
                success: true,
                data: res.body.data
              });
            } else {
              resolve({
                success: false,
                data: {
                  code: res.body.code,
                  error: res.body.message || res.body.remark
                }
              });
              self.$message.error(res.body.message || res.body.remark);
            }
          }
        });
    });
  }
  /**新增地址 */
  createAddress(self,data){
    return new Promise((resolve, reject) => {
      request
        .post(self, {
          action: "kdyserver.address.createAddress",
          data 
        })
        .then(res => {
          if (res.success) {
            if (res.body.result) {
              resolve({
                success: true,
                data: res.body.data
              });
            } else {
              resolve({
                success: false,
                data: {
                  code: res.body.code,
                  error: res.body.message || res.body.remark
                }
              });
              self.$message.error(res.body.message || res.body.remark);
            }
          }
        });
    });
  }
  /**上传文件 */
  upLoadFile(self,data,url) {
    return new Promise((resolve, reject) => {
      request.fileAxios(self,data,url).then(res => {
        if (res.result) {
          resolve({
            success: true,
            data: res.data
          })
        } else {
          resolve({
            success: false,
            data: {
              code: res.code,
              error: res.message || res.remark
            }
          })
        }
      })
      .catch((rej)=>{
        console.log(rej); 
      })
    });

  }
  /**上传联系人文件 */
  upLoadaddress(self,data,url) {
    return new Promise((resolve, reject) => {
      request.fileAxios(self,data,url).then(res => {
        if (res.result) {
          resolve({
            success: true,
            data: res.data
          })
        } else {
          resolve({
            success: false,
            data: {
              code: res.code,
              error: res.message || res.remark
            }
          })
        }
      })
      .catch((rej)=>{
        console.log(rej);  
      })
    });

  }
  /**上传量信息 */
  getTempOrder(self,page){
    return new Promise((resolve, reject) => {
      const commondata = {
        account_id: util.getCookie("account_id"),  
      }
      // debugger
      let data = Object.assign(page,commondata);
      request
        .post(self, {
          action: "kdyserver.file.getTempOrder",
          data
        })
        .then(res => {
          if (res.success) {
            if (res.body.result) {
              resolve({
                success: true,
                data: res.body.data
              });
            } else {
              resolve({
                success: false,
                data: {
                  code: res.body.code,
                  error: res.body.message || res.body.remark
                }
              });
              self.$message.error(res.body.message || res.body.remark);
            }
          }
        });
    });
  }
  /**删除临时包裹 */
  delTempOrder(self,ids){
    return new Promise((resolve, reject) => {
      request
        .post(self, {
          action: "kdyserver.file.delTempOrder",
          data: {
            account_id: util.getCookie("account_id"),
            ids
          }
        })
        .then(res => {
          if (res.success) {
            if (res.body.result) {
              resolve({
                success: true,
                data: res.body.data
              });
            } else {
              resolve({
                success: false,
                data: {
                  code: res.body.code,
                  error: res.body.message || res.body.remark
                }
              });
              self.$message.error(res.body.message || res.body.remark);
            }
          }
        });
    });
  }
  /**获取临时包裹id*/
  getTempOrderIds(self){
    return new Promise((resolve, reject) => {
      request
        .post(self, {
          action: "kdyserver.file.getTempOrderIds",
          data: {
            account_id: util.getCookie("account_id"),
          }
        })
        .then(res => {
          if (res.success) {
            if (res.body.result) {
              resolve({
                success: true,
                data: res.body.data
              });
            } else {
              resolve({
                success: false,
                data: {
                  code: res.body.code,
                  error: res.body.message || res.body.remark
                }
              });
              self.$message.error(res.body.message || res.body.remark);
            }
          }
        });
    });
  }
  /**包裹保存至待打印 */
  saveTempOrder(self,ids){
    return new Promise((resolve, reject) => {
      request
        .post(self, {
          action: "kdyserver.file.saveTempOrder",
          data: {
            source:9,
            account_id: util.getCookie("account_id"),
            pri:self.ysBill ? 'PRI' : 'PT',
            value_add_type:self.value_add_type ? 'topay' : 'pt',
            ids
          }
        })
        .then(res => {
          if (res.success) {
            if (res.body.result) {
              resolve({
                success: true,
                data: res.body.data
              });
            } else {
              resolve({
                success: false,
                data: {
                  code: res.body.code,
                  error: res.body.message || res.body.remark
                }
              });
              self.$message.error(res.body.message || res.body.remark);
            }
          }
        });
    });
  }
  //删除地址
  delAddress(self,id){
    return new Promise((resolve, reject) => {
      request
        .post(self, {
          action: "kdyserver.address.deleteAddress",
          data: {
            account_id: util.getCookie("account_id"),
            id,
          }
        })
        .then(res => {
          if (res.success) {
            if (res.body.result) {
              resolve({
                success: true,
                data: res.body.data
              });
            } else {
              resolve({
                success: false,
                data: {
                  code: res.body.code,
                  error: res.body.message || res.body.remark
                }
              });
              self.$message.error(res.body.message || res.body.remark);
            }
          }
        });
    });
  }
  //批量删除地址
  alldelAddress(self,ids){
    return new Promise((resolve, reject) => {
      request
        .post(self, {
          action: "kdyserver.address.pc.delAddresses",
          data: {
            account_id: util.getCookie("account_id"),
            ids,
          }
        })
        .then(res => {
          if (res.success) {
            if (res.body.result) {
              resolve({
                success: true,
                data: res.body.data
              });
            } else {
              resolve({
                success: false,
                data: {
                  code: res.body.code,
                  error: res.body.message || res.body.remark
                }
              });
              self.$message.error(res.body.message || res.body.remark);
            }
          }
        });
    });
  }
  //获取公共信息
  commondict(self){
    return new Promise((resolve, reject) => {
      request
        .post(self, {
          action: "kdyserver.account.commondict",
          data: {
            account_id: util.getCookie("account_id"),
          }
        })
        .then(res => {
          if (res.success) {
            if (res.body.result) {
              resolve({
                success: true,
                data: res.body
              });
            } else {
              resolve({
                success: false,
                data: {
                  code: res.body.code,
                  error: res.body.message || res.body.remark
                }
              });
              self.$message.error(res.body.message || res.body.remark);
            }
          }
        });
    });
  }
  //签收统计数据
  signStatistics(self,data){
    return new Promise((resolve, reject) => {
      request
        .post(self, {
          action: "kdyserver.order.logistics.statistics",
          data
        })
        .then(res => {
          if (res.success) {
            if (res.body.result) {
              resolve({
                success: true,
                data: res.body.data
              });
            } else {
              resolve({
                success: false,
                data: {
                  code: res.body.code,
                  error: res.body.message || res.body.remark
                }
              });
              self.$message.error(res.body.message || res.body.remark);
            }
          }
        });
    });
  }
  //增值服务列表查询
  addAuth(self){
    return new Promise((resolve, reject) => {
      request
        .post(self, {
          action: "kdyserver.account.getAccountAddServiceAuth",
          data: {
            account_id: util.getCookie("account_id"),
          }
        })
        .then(res => {
          if (res.success) {
            if (res.body.result) {
              resolve({
                success: true,
                data: res.body.data
              });
            } else {
              resolve({
                success: false,
                data: {
                  code: res.body.code,
                  error: res.body.message || res.body.remark
                }
              });
              self.$message.error(res.body.message || res.body.remark);
            }
          }
        });
    });
  }
  //地址联想列表
  lxAddress(self,name,type){
    return new Promise((resolve, reject) => {
      request
        .post(self, {
          action: "kdyserver.address.associateAddress",
          data: {
            account_id: util.getCookie("account_id"),
            address_type: type,
            name
          }
        })
        .then(res => {
          if (res.success) {
            if (res.body.result) {
              resolve({
                success: true,
                data: res.body.data
              });
            } else {
              resolve({
                success: false,
                data: {
                  code: res.body.code,
                  error: res.body.message || res.body.remark
                }
              });
              self.$message.error(res.body.message || res.body.remark);
            }
          }
        });
    });
  }
  //地址查找
  getAddressById(self,id){
    return new Promise((resolve, reject) => {
      request
        .post(self, {
          action: "kdyserver.address.getAddressById",
          data: {
            account_id: util.getCookie("account_id"),
            id
          }
        })
        .then(res => {
          if (res.success) {
            if (res.body.result) {
              resolve({
                success: true,
                data: res.body.data
              });
            } else {
              resolve({
                success: false,
                data: {
                  code: res.body.code,
                  error: res.body.message || res.body.remark
                }
              });
              self.$message.error(res.body.message || res.body.remark);
            }
          }
        });
    });
  }
  //代客下单提交快递员
  orderToywy(self,data){
    return new Promise((resolve, reject) => {
      request
        .post(self, {
          action: "kdyserver.order.toywy",
          data
        })
        .then(res => {
          if (res.success) {
            if (res.body.result) {
              resolve({
                success: true,
                data: res.body.data
              });
            } else {
              resolve({
                success: false,
                data: {
                  code: res.body.code,
                  error: res.body.message || res.body.remark
                }
              });
              self.$message.error(res.body.message || res.body.remark);
            }
          }
        });
    });
  }
  //代客下单先存后打
  orderForwait(self,data){
    return new Promise((resolve, reject) => {
      request
        .post(self, {
          action: "kdyserver.order.agent.saveprint",
          data
        })
        .then(res => {
          if (res.success) {
            if (res.body.result) {
              resolve({
                success: true,
                data: res.body.data
              });
            } else {
              resolve({
                success: false,
                data: {
                  code: res.body.code,
                  error: res.body.message || res.body.remark
                }
              });
              self.$message.error(res.body.message || res.body.remark);
            }
          }
        });
    });
  }
  //代客下单身份验证
  Idvalidate(self){
    return new Promise((resolve, reject) => {
      request
        .post(self, {
          action: "kdyserver.order.idcard.validate",
          data:{
            name:self.realForm.name,
            id_card:self.realForm.id,
            card_type:self.realForm.card_type,
            phone:self.ruleForm.send.phone,
          }
        })
        .then(res => {
          if (res.success) {
            if (res.body.result) {
              resolve({
                success: true,
                data: res.body.data
              });
            } else {
              resolve({
                success: false,
                data: {
                  code: res.body.code,
                  error: res.body.message || res.body.remark
                }
              });
              self.$message.error(res.body.message || res.body.remark);
            }
          }
        });
    });
  }
  //代客下单打印
  // agentPrint(self, data){
  //   return new Promise((resolve, reject) => {
  //     request
  //       .post(self, {
  //         action: "kdyserver.order.agent.directprint",
  //         data:data
  //       })
  //       .then(res => {
  //         if (res.success) {
  //           if (res.body.result) {
  //             resolve({
  //               success: true,
  //               data: res.body.data
  //             });
  //           } else {
  //             resolve({
  //               success: false,
  //               data: {
  //                 code: res.body.code,
  //                 error: res.body.message || res.body.remark
  //               }
  //             });
  //             self.$message.error(res.body.message || res.body.remark);
  //           }
  //         }
  //       });
  //   });
  // }
  // 代客下单记录实名
  saveIdinfo(self, data){
    return new Promise((resolve, reject) => {
      request
        .post(self, {
          action: "kdyserver.order.agent.idcard",
          data:data
        })
        .then(res => {
          if (res.success) {
            if (res.body.result) {
              resolve({
                success: true,
                data: res.body.data
              });
            } else {
              resolve({
                success: false,
                data: {
                  code: res.body.code,
                  error: res.body.message || res.body.remark
                }
              });
              // self.$message.error(res.body.message || res.body.remark);
            }
          }
        });
    });
  }
  //修改订单
  updataBill(self,data){
    return new Promise((resolve, reject) => {
      request
        .post(self, {
          action: "kdyserver.order.modify",
          data
        })
        .then(res => {
          if (res.success) {
            if (res.body.result) {
              resolve({
                success: true,
                data: res.body.data
              });
            } else {
              resolve({
                success: false,
                data: {
                  code: res.body.code,
                  error: res.body.message || res.body.remark
                }
              });
              self.$message.error(res.body.message || res.body.remark);
            }
          }
        });
    });
  }
  getthreeNum(data) {
    return new Promise((resolve, reject) => {
      request
        .post(self, {
          action: "kdyserver.order.logistics.orderstatic",
          data
        })
        .then(res => {
          if (res.success) {
            if (res.body.result) {
              resolve({
                success: true,
                data: res.body.data
              });
            } else {
              resolve({
                success: false,
                data: {
                  code: res.body.code,
                  error: res.body.message || res.body.remark
                }
              });
              self.$message.error(res.body.message || res.body.remark);
            }
          }
        });
    });
  }
  getBillNum(self,data) {
    return new Promise((resolve, reject) => {
      request
        .post(self, {
          action: "kdyserver.order.printOrderStatics",
          data:data
        })
        .then(res => {
          if (res.success) {
            if (res.body.result) {
              resolve({
                success: true,
                data: res.body.data
              });
            } else {
              resolve({
                success: false,
                data: {
                  code: res.body.code,
                  error: res.body.message || res.body.remark
                }
              });
              self.$message.error(res.body.message || res.body.remark);
            }
          }
        });
    });
  }
  checkaddress(self,data) {
    return new Promise((resolve, reject) => {
      request
        .post(self, {
          action: "kdyserver.order.checkaddressstatus",
          data:data
        })
        .then(res => {
          if (res.success) {
            if (res.body.result) {
              resolve({
                success: true,
                data: res.body.data
              });
            } else {
              resolve({
                success: false,
                data: {
                  code: res.body.code,
                  error: res.body.message || res.body.remark
                }
              });
              self.$message.error(res.body.message || res.body.remark);
            }
          }
        });
    });
  }
  //敏感词检验
  sensitivewords(self,data) {
    return new Promise((resolve, reject) => {
      request
        .post(self, {
          action: "kdyserver.address.sensitivewords.check",
          data:data
        })
        .then(res => {
          if (res.success) {
            if (res.body.result) {
              resolve({
                success: true,
                data: res.body.data
              });
            } else {
              resolve({
                success: false,
                data: {
                  code: res.body.code,
                  error: res.body.message || res.body.remark
                }
              });
              self.$message.error(res.body.message || res.body.remark);
            }
          }
        });
    });
  }
  // 获取最近一次下单物品信息
  getCurrentMailGoodsType = (data = {}) => request.post(null, {
    action: 'kdyserver.order.user.lately.orderGoods',
    data,
  })
  // 获取自定义物品类型记录
  getCustomMailGoodsTypeRecords = (data = {}) => request.post(null, {
    action: 'kdyserver.order.user.lately.goods.qry',
    data,
  })
  // 新增自定义物品类型记录
  createCustomMailGoodsTypeRecord = data => request.post(null, {
    action: 'kdyserver.order.user.lately.goods.add',
    data,
  })
  // 删除自定义物品类型记录
  removeCustomMailGoodsTypeRecord = (ids) => request.post(null, {
    action: 'kdyserver.order.user.lately.goods.remove',
    data: { ids },
  })

  // 图形验证码
  getImgCaptcha(self, data) {
    return new Promise((resolve, reject) => {
      request
        .post(self, {
          action: "kdyserver.account.captcha.get",
          data: data
        })
        .then(res => {
          if (res.success) {
            if (res.body.result) {
              resolve({
                success: true,
                data: res.body.data
              });
            } else {
              resolve({
                success: false,
                data: {
                  code: res.body.code,
                  error: res.body.message || res.body.remark
                }
              });
              self.$message.error(res.body.message || res.body.remark);
            }
          }
        });
    });
  }
  // 图形验证码
  checkImgCaptcha(self, data) {
    return new Promise((resolve, reject) => {
      request
        .post(self, {
          action: "kdyserver.account.captcha.check",
          data: data
        })
        .then(res => {
          if (res.success) {
            if (res.body.result) {
              resolve({
                success: true,
                data: res.body.data
              });
            } else {
              resolve({
                success: false,
                data: {
                  code: res.body.code,
                  error: res.body.message || res.body.remark
                }
              });
              // self.$message.error(res.body.message || res.body.remark);
            }
          }
        });
    });
  }
  //韵商宝获取验证码
  ysbGetCode(self, data) {
    return new Promise((resolve, reject) => {
      request.post(self, {
        action: "kdyserver.account.sendMessage.blockPuzzle",
        data: data
      }).then(res => {
        if (res.success && res.body.result) {
          resolve({
            success: true,
            data: res.body
          })
        } else {
          resolve({
            success: false,
            // msg:res.body
            data: {
              code: res.body.code,
              error: res.body.message || res.body.remark
            }
          })
          self.$message.error(res.body.message || res.body.remark);
        }
      })
    });  
  }
  //图片解析地址
  analysisImageAddress(self, image) {
    return new Promise((resolve, reject) => {
      request.post(self, {
        action: "kdyserver.address.analysisImageAddress",
        data: {
          account_id: util.getCookie("account_id"),
          image:image
        }
      }).then(res => {
        if (res.body.code == 200) {
          resolve({
            success: true,
            data: res.body.data
          })
        } else {
          resolve({
            success: false,
            // msg:res.body
            data: {
              code: res.body.code,
              error: res.body.message || res.body.remark
            }
          })
          self.$message.error(res.body.message || res.body.remark);
        }
      })
    });  
  }

  //**获取订单备注 */
  getRemarks(self) {
    return new Promise((resolve, reject) => {
      request
        .post(self, {
          action: "kdyserver.account.getCommonlyOrderRemarks",
          data: {
            account_id: util.getCookie("account_id"),
          }
        })
        .then(res => {
          // debugger
          if (res.success) {
               resolve({
                success: true,
                data: res.body
              });
          //   if (res.body.result) {
          //     resolve({
          //       success: true,
          //       data: res.body.data
          //     });
          //   } else {
          //     resolve({
          //       success: false,
          //       data: {
          //         code: res.body.code,
          //         error: res.body.message || res.body.remark
          //       }
          //     });
          //     self.$message.error(res.body.message || res.body.remark);
          //   }
          }
        });
    });
  }

    //**保存订单备注 */
    saveRemarks(self,str) {
      return new Promise((resolve, reject) => {
        request
          .post(self, {
            action: "kdyserver.account.saveCommonlyOrderRemark",
            data: {
              account_id: util.getCookie("account_id"),
              commonly_order_remark:str
            }
          })
          .then(res => {
            // debugger
            if (res.success) {
                //  resolve({
                //   success: true,
                //   data: res.body
                // });
              if (res.body.result) {
                resolve({
                  success: true,
                  data: res.body.data
                });
              } else {
                resolve({
                  success: false,
                  data: {
                    code: res.body.code,
                    error: res.body.message || res.body.remark
                  }
                });
                self.$message.error(res.body.message || res.body.remark);
              }
            }
          });
      });
    }
  
    //**删除订单备注 */
    delRemarks(self,obj) {
      return new Promise((resolve, reject) => {
        request
          .post(self, {
            action: "kdyserver.account.deleteCommonlyOrderRemark",
            data: {
              account_id: util.getCookie("account_id"),
              commonly_order_remark:obj.commonly_order_remark
            }
          })
          .then(res => {
            // debugger
            if (res.success) {
                //  resolve({
                //   success: true,
                //   data: res.body
                // });
              if (res.body.result) {
                resolve({
                  success: true,
                  data: res.body.data
                });
              } else {
                resolve({
                  success: false,
                  data: {
                    code: res.body.code,
                    error: res.body.message || res.body.remark
                  }
                });
                self.$message.error(res.body.message || res.body.remark);
              }
            }
          });
      });
    }
  //**获取物品类型 */
  getTypeArr(self) {
    return new Promise((resolve, reject) => {
      request
        .post(self, {
          action: "kdyserver.order.getOrderItemTypeList",
          data: {
            account_id: util.getCookie("account_id"),
          }
        })
        .then(res => {
          // debugger
          if (res.success) {
               resolve({
                success: true,
                data: res.body
              });
          }
        });
    });
  }
}

export default new home();
